export default __webpack_public_path__ + "static/media/ridehail.093afea0.svg";